import { useState } from 'react';
var EDGE_REACH_THRESHOLD = 5;
export var useScrollManager = function (listRef) {
    var _a;
    var _b = useState(((_a = listRef.current) === null || _a === void 0 ? void 0 : _a.scrollTop) || 0), previousScrollTop = _b[0], setPreviousScrollTop = _b[1];
    var scrollDown = function (behaviour) {
        if (behaviour === void 0) { behaviour = undefined; }
        if (listRef.current) {
            var _a = listRef.current, scrollHeight = _a.scrollHeight, clientHeight = _a.clientHeight;
            if (scrollHeight > clientHeight) {
                listRef.current.scrollTo({ top: scrollHeight - clientHeight, behavior: behaviour });
            }
        }
    };
    var preserveScrollPosition = function (previousScrollHeight) {
        if (listRef.current) {
            var scrollHeight = listRef.current.scrollHeight;
            listRef.current.scrollTop = scrollHeight - previousScrollHeight;
        }
    };
    // this function is called within scroll handler
    var onEdgeReached = function (topEdgeHandler, bottomEdgeHandler) {
        if (listRef.current) {
            var _a = listRef.current, scrollTop = _a.scrollTop, scrollHeight = _a.scrollHeight, clientHeight = _a.clientHeight;
            // top edge
            if (previousScrollTop > scrollTop && scrollTop < EDGE_REACH_THRESHOLD) {
                topEdgeHandler();
            }
            setPreviousScrollTop(scrollTop);
            // bottom edge
            if (scrollHeight - clientHeight - scrollTop < EDGE_REACH_THRESHOLD) {
                bottomEdgeHandler();
            }
        }
    };
    return {
        scrollDown: scrollDown,
        preserveScrollPosition: preserveScrollPosition,
        onEdgeReached: onEdgeReached
    };
};
//# sourceMappingURL=scrollManagerHook.js.map